import React from 'react'

export default function VerticalSpace(props) {
    return (
       <span className='verticalSpace' style={{padding:props.spaceHeight}}></span>
    )
}
